const SDK_VERSION = '8.38.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
